import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import furnituresProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import * as R from 'ramda';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';

const Bench = R.pipe(withCategoryFilter(['benches']));
const Desk = R.pipe(withCategoryFilter(['desk']));
const Bed = R.pipe(withCategoryFilter(['loft-bed']));

const widgets = {
  desktop: [
    {
      id: 'furnitures-product-list',
      component: withProducts(ProductList, furnituresProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'bench-product-list',
      component: Bench(withProducts(ProductSwiper, furnituresProductListConfig)),
      title: 'storageone.productListCategoryTitleBench'
    },
    {
      id: 'desk-product-list',
      component: Desk(withProducts(ProductSwiper, furnituresProductListConfig)),
      title: 'storageone.productListCategoryTitleDeskChangingTable'
    },
    {
      id: 'bed-product-list',
      component: Bed(withProducts(ProductSwiper, furnituresProductListConfig)),
      title: 'storageone.productListCategoryTitleLoftBed'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListFurnituresTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: [],
  widgets: widgets[platform]
};

export default mainMenu;
